// extracted by mini-css-extract-plugin
export default {"headerWrapper":"Header_headerWrapper__TsAVN","headerRowWrapper":"Header_headerRowWrapper__Qq9Y1","logo":"Header_logo__qZpTt","logoText":"Header_logoText__DbrDL"};